module.exports = __webpack_public_path__ + "static/media/sih_team.e7f89ae9.jpg";